const scrollTopButton = document.getElementById('scroll-to-top-button');
const scrollTopButtonContainer = document.querySelector('.scroll-to-top-container');

function scrollToTop(step) {
    window.scrollTo(0, window.scrollY - step);
    if (window.scrollY > 0) {
        window.requestAnimationFrame(() => {
            scrollToTop(step);
        });
    }
}
function calculateScrollStep(seconds) {
    return window.scrollY / (seconds * 60);
}
function showScrollTopButton() {
    scrollTopButtonContainer.classList.add('visible');
}
function hideScrollTopButton() {
    scrollTopButtonContainer.classList.remove('visible');
}

if (scrollTopButton) {
    let ticking = false;
    let windowHeight = window.innerHeight;

    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                if (window.scrollY > windowHeight / 2) {
                    showScrollTopButton();
                } else {
                    hideScrollTopButton();
                }
                ticking = false;
            });
        }
        ticking = true;
    });

    scrollTopButton.addEventListener('click', e => {
        e.preventDefault();
        scrollToTop(calculateScrollStep(.6));
    });
}



// WEBPACK FOOTER //
// ./assets/js/src/modules/scrollTop.js